export default __webpack_public_path__ + "static/PaPIR_Specifications-af517c02269e3c61e4e71f78227c97a8.png";